/**
 * API Configuration
 * 
 * Centralized API URL configuration with fail-fast behavior.
 * Prevents silent fallback to localhost in production.
 */

// In development, allow localhost fallback for convenience
const isDevelopment = process.env.NODE_ENV === 'development';

// Get API URL from environment
const API_URL = process.env.REACT_APP_BACKEND_URL;

// Fail-fast: In production, REACT_APP_BACKEND_URL MUST be set
if (!isDevelopment && !API_URL) {
  console.error('❌ CRITICAL: REACT_APP_BACKEND_URL is not set in production build!');
  console.error('This will cause API calls to fail. Please set REACT_APP_BACKEND_URL in build environment.');
  // Don't throw in production to avoid breaking the entire app
  // Instead, log prominently and let individual API calls fail with clear errors
}

// In development, fall back to localhost for convenience
// In production, use the environment variable (will be undefined if not set, causing clear API errors)
export const API = isDevelopment 
  ? (API_URL || 'http://localhost:8001')
  : API_URL;

// Export a function to check if API is properly configured
export const isApiConfigured = () => Boolean(API);

// Export for debugging
export const getApiConfig = () => ({
  API_URL: API,
  NODE_ENV: process.env.NODE_ENV,
  isConfigured: isApiConfigured(),
});

export default API;
